// T031, T033 — Per-station-owner wallet-credit drill-down + the v1 refund
// acknowledgement badge. Renders nothing extra when there's no wallet activity
// (FR-024) so the screen behaves identically to before this feature.
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Tag } from "primereact/tag";

interface WalletCreditByOwnerProps {
  walletCreditByCustomer: Record<string, number> | null | undefined;
  refundsAcknowledgedV1: boolean | undefined;
}

interface OwnerRow {
  stationOwnerId: string;
  walletCredit: number;
}

const formatEuro = (value: number) =>
  value.toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const WalletCreditByOwner = ({
  walletCreditByCustomer,
  refundsAcknowledgedV1,
}: WalletCreditByOwnerProps) => {
  // FR-020 / FR-024 — when no wallet activity, render nothing extra; the
  // existing screen behaves exactly as before.
  if (!walletCreditByCustomer) return null;

  const rows: OwnerRow[] = Object.entries(walletCreditByCustomer).map(
    ([stationOwnerId, walletCredit]) => ({ stationOwnerId, walletCredit }),
  );

  if (rows.length === 0) return null;

  return (
    <Card className="mt-4">
      <div className="flex align-items-center justify-content-between mb-3">
        <h4 className="m-0">Wallet credit by station owner</h4>
        {refundsAcknowledgedV1 === false && (
          <Tag
            severity="warning"
            value="v1: refund handling for credit-funded sessions not yet integrated"
            icon="pi pi-info-circle"
            className="text-xs"
          />
        )}
      </div>
      <DataTable value={rows} size="small">
        <Column field="stationOwnerId" header="Station owner" sortable />
        <Column
          header="Wallet credit"
          sortable
          sortField="walletCredit"
          body={(row: OwnerRow) => formatEuro(row.walletCredit)}
        />
      </DataTable>
    </Card>
  );
};

export default WalletCreditByOwner;
